//
//
//      启动编辑器，加载默认图
//
//
export default {
    methods: {
        InitEditor() {
            function jQ(str) {
                return window.$(str);
            }
            var _this = this;
            _this.bodyCon = jQ(".body-container");
            _this.theBody = jQ("body");
            var defPic = "img/gen/pic_tianjiatupian.png";
            //defPic = 'img/猫1114-1.jpg';
            var imageEditor = window.imageEditor = new window.tui.ImageEditor(
                ".tui-image-editor", {
                    includeUI: {
                        menu: ["icon"],
                        initMenu: "icon"
                    },
                    //扩展图形必须引用这一套
                    cssMaxWidth: _this.tW,
                    cssMaxHeight: _this.tH,
                    selectionStyle: {
                        //这里调节选框手柄样式
                        cornerColor: "#376FFF",
                        cornerSize: 15,
                        rotatingPointOffset: 70
                    }
                }
            );
            //这里加载这张默认图，用户是看不见的，只是为了初始化
            imageEditor.loadImageFromURL(defPic, "我的作品").then(function () {
                _this.inpFileLoad = jQ(".tui-image-editor-load-btn");
                _this.theCanvas = jQ(".tui-image-editor-canvas-container");
                var redEditor = jQ(".tui-image-editor.red1");
                redEditor.removeClass("red1");
                redEditor.removeClass("tui-image-editor");
                //不然会存在 2 个，这里不需要画布居中，用户看不见
                _this.theEditor = jQ(".tui-image-editor");
                imageEditor.clearUndoStack(); //必须清理堆栈，防止能撤销
                _this.InitBasic(); //加载，保存，选择，undo，redo，reset，del
                _this.InitDrop();
                window.colPick.init('text');
                window.colPick.init('shape');
            });
            imageEditor.on({
                objectActivated: function (obj) {
                    window.aoId = obj.id;
                    window.aoTp = obj.type;
                    //创建时自动选中，或者点了某个
                    //比如当前 SHAPE，直接选文字
                    //如果不切入 mod TEXT，就无法双击编辑
                    //也不能 objectScaled 改变 fontSize
                    if (obj.type == 'text') {
                        window.$('.menu-edit').hide();
                        _this.chanMenu('text');
                        _this.chanBtn('text');
                        imageEditor.startDrawingMode("TEXT");
                        var sz = Math.round(obj.fontSize)
                        var txt = window.txtPick;
                        txt.txSz.val(sz + 'pt');
                    }
                    if (obj.type == 'rect') {
                        //console.log(imageEditor.getDrawingMode())
                        //如果是 TEXT，来个自动选中它
                        _this.chanMenu('shape');
                        _this.ModSel();
                        _this.ShowRectSize(obj, 'shape');
                    }
                    if (obj.type == 'cropzone') {
                        _this.ShowRectSize(obj, 'crop');
                        _this.showCrop(true);
                    }
                },
                textEditing: function () {
                    //仅仅只是双击进去一瞬间，也不能调出任何参数
                    window.$('.menu-text').hide();
                    window.$('.menu-edit').show();
                    imageEditor.stopDrawingMode(); //一定要先结束，才能得到 aoId
                    var txtEdit = window.$('.menu-edit').find('textarea');
                    var str = imageEditor.getObjectProperties(window.aoId, 'text');
                    txtEdit.val(str.text);
                    txtEdit.focus();
                },
                objectScaled: function (obj) {
                    if (obj.type == "text") {
                        //点到那个选择框就会触发
                        var sz = Math.round(obj.fontSize);
                        var txt = window.txtPick;
                        txt.txSz.val(sz + 'pt');
                        txt.textStyle.fontSize = sz;
                        txt.ChanTS(obj.id, 'size', sz);
                    }
                    if (obj.type == 'rect') {
                        _this.ShowRectSize(obj, 'shape');
                    }
                    if (obj.type == 'cropzone') {
                        _this.ShowRectSize(obj, 'crop');
                    }
                },
                addText: function (pos) {
                    var txt = window.txtPick;
                    imageEditor
                        .addText("输入文字", {
                            styles: txt.textStyle,
                            position: pos.originPosition
                        })
                        .then(function (obj) {
                            //能回调刚创建出来的文字
                            txt.PushTS(obj, "new");
                        });
                },
                addObjectAfter: function (obj) {
                    _this.ShowRectSize(obj, 'shape');
                },
                undoStackChanged: function (length) {
                    if (length) {
                        //
                    }
                    _this.resizeEditor(); //假如有图形重做，所以这里需要额外添加
                },
                redoStackChanged: function (length) {
                    if (length) {
                        //
                    }
                    _this.resizeEditor();
                }
            });
        },
        ShowRectSize(obj, type) {
            if (!obj) {
                return;
            } // SHAPE 模式，用户单击的话
            var w = Math.round(obj.width);
            var h = Math.round(obj.height);
            var menu = type == 'crop' ? '.menu-crop' : '.menu-shape';
            var inp = window.$(menu).find('.twin').find('p');
            inp.eq(0).html('高：' + h + 'px');
            inp.eq(1).html('宽：' + w + 'px');
        },
        //在实例化完成之前，会被调用一次，这时候还没生成
        //并且在各种图形添加，旋转，镜像，操作后也，因为改变堆栈被调用一次
        resizeEditor() {
            var _this = this;
            if (_this.theCanvas != undefined) {
                _this.theEditor.width(_this.tW);
                _this.theEditor.height(_this.tH);
            }
            window.imageEditor.clearUndoStack();
        },
        //让画布始终居中
        rePage() {
            var _this = this;
            _this.bodyCon.width(820);
            _this.bodyCon.height(440);
        }
    }
};